import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FacilityGrid } from 'components/search/FacilityGrid';
import { H2, Paragraph } from 'components/core/Typography';

import { Link } from 'components/core/Link';

import './facilityRow.scss';


export function FacilityRow({
	facilities,
	cityURL,
	location,
	className,
	storageType,
	headline = 'Self-storage near you',
	linkText,
	subheading,
	withPhone,
	withUnitsAndPrice,
	withButtonLink,
	noFollowCityURL,
	searchId,
	headerSize
}) {
	return (
		<div className={classnames('facility-row', className)}>
			<div className="section-content">
				{!!headline && (
					<H2
						size={headerSize}
						className="hero-header facility-row-headline"
					>
						{headline}
					</H2>
				)}
				{!!subheading && (
					<Paragraph
						size="small"
						centered
						className="facility-row-subheading"
					>
						{subheading}
					</Paragraph>
				)}
				<FacilityGrid
					facilities={facilities}
					withPhone={withPhone}
					withUnitsAndPrice={withUnitsAndPrice}
					withButtonLink={withButtonLink}
					searchId={searchId}
				/>
				{!!location && cityURL && (
					<div className="more-facilities">
						<Link
							href={cityURL}
							rel={noFollowCityURL ? 'nofollow' : ''}
						>
							{linkText ||
								`View more ${storageType} in ${location.city}`}
						</Link>
					</div>
				)}
			</div>
		</div>
	);
}

FacilityRow.propTypes = {
	facilities: PropTypes.arrayOf(PropTypes.object),
	cityURL: PropTypes.string,
	location: PropTypes.object,
	className: PropTypes.string,
	storageType: PropTypes.string,
	headline: PropTypes.string,
	linkText: PropTypes.string,
	subheading: PropTypes.string,
	withPhone: PropTypes.bool,
	withUnitsAndPrice: PropTypes.bool,
	withButtonLink: PropTypes.bool,
	noFollowCityURL: PropTypes.bool,
	searchId: PropTypes.string,
	headerSize: PropTypes.string
};

export default React.memo(FacilityRow);
